module.exports = __webpack_public_path__ + "img/hero-bg-03.22082776.jpg";